import { Producto } from '../types';

// Función auxiliar para generar valores aleatorios
const randomStock = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Función para generar entradas y salidas realistas
const generateMovimientos = (stockFinal: number): { entradas: number; salidas: number } => {
  const entradas = stockFinal + Math.floor(Math.random() * 10) + 5;
  const salidas = entradas - stockFinal;
  return { entradas, salidas };
};

// Función para crear un producto con valores aleatorios
const createProduct = (
  id: string,
  categoria: string,
  producto: string,
  unidad: string,
  proveedor: string,
  stockMinimo: number,
  stockMaximo: number,
  tipoProducto: 'basico' | 'especialidad' | 'premium' = 'basico'
): Producto => {
  const stockFinal = randomStock(stockMinimo, stockMaximo);
  const { entradas, salidas } = generateMovimientos(stockFinal);
  const puntoReorden = Math.floor(stockMinimo + (stockMaximo - stockMinimo) * 0.3);
  
  return {
    id,
    fecha: new Date().toISOString().split('T')[0],
    categoria,
    producto,
    unidad,
    proveedor,
    entradas,
    fechaEntrada: new Date().toISOString().split('T')[0],
    fechaCaducidad: '',
    salidas,
    mermas: Math.floor(Math.random() * 2),
    stockFinal,
    stockMinimo,
    stockMaximo,
    puntoReorden,
    tipoProducto
  };
};

export const inventarioInicial: Producto[] = [
  // ALIMENTOS - Salados
  createProduct('alim-salado-001', 'Alimentos - Salados', 'Baguette Philadelphia', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-salado-002', 'Alimentos - Salados', 'Baguette de Pepperoni', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-salado-003', 'Alimentos - Salados', 'Empanada de Jamón C/ queso', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-salado-004', 'Alimentos - Salados', 'Empanada de Lomo Canadiense', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-salado-005', 'Alimentos - Salados', 'Empanada de Selva negra', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-salado-006', 'Alimentos - Salados', 'Croissant de Jamón c/ queso', 'pza', 'Panaderia/Isa', 5, 20),

  // ALIMENTOS - Dulces
  createProduct('alim-dulce-001', 'Alimentos - Dulces', 'Croissant de Chocolate', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-dulce-002', 'Alimentos - Dulces', 'Galletas Integral', 'pza', 'Panaderia/Isa', 10, 50),
  createProduct('alim-dulce-003', 'Alimentos - Dulces', 'Galletas Nuez', '1 kg', 'Panaderia/Isa', 2, 10),
  createProduct('alim-dulce-004', 'Alimentos - Dulces', 'Muffin de Queso c/ Zarzamora', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-dulce-005', 'Alimentos - Dulces', 'Muffin de Manzana/canela', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-dulce-006', 'Alimentos - Dulces', 'Muffin de Chocolate', 'pza', 'Panaderia/Isa', 5, 20),
  createProduct('alim-dulce-007', 'Alimentos - Dulces', 'Muffin de Frutos Rojos', 'pza', 'Panaderia/Isa', 5, 20),

  // BEBIDAS
  createProduct('bebida-001', 'Bebidas - Agua Mineral', 'Agua Mineral', '2L', 'Ash y Maryl', 10, 50),
  createProduct('bebida-002', 'Bebidas - Café', 'Bolsa de café', '1 kg', 'Grano x Grano (Daniel/Javier)', 5, 20, 'premium'),
  createProduct('bebida-003', 'Bebidas - Cítricos', 'Limones', 'kg', 'Ash y Maryl', 2, 10),
  createProduct('bebida-004', 'Bebidas - Cítricos', 'Naranjas', 'kg', 'Ash y Maryl', 2, 10),

  // JARABES
  createProduct('jarabe-001', 'Bebidas - Jarabes', 'Jarabe de Chocolate Gialinni', '3.78L', 'Discount Coffee', 1, 5, 'especialidad'),
  createProduct('jarabe-002', 'Bebidas - Jarabes', 'Jarabe de crema irlandesa', '1L', 'Discount Coffee', 2, 10, 'especialidad'),
  createProduct('jarabe-003', 'Bebidas - Jarabes', 'Jarabe de vainilla', '1L', 'Discount Coffee', 2, 10, 'especialidad'),

  // LECHE
  createProduct('leche-001', 'Bebidas - Leche', 'Leche de Almendra GUD', '1L', 'Retto', 5, 20, 'especialidad'),
  createProduct('leche-002', 'Bebidas - Leche', 'Leche de Avena GUD', '1L', 'Retto', 5, 20, 'especialidad'),
  createProduct('leche-003', 'Bebidas - Leche', 'Leche deslactosada Bove', '1L', 'Retto', 10, 30),
  createProduct('leche-004', 'Bebidas - Leche', 'Leche Entera Bove', '1L', 'Retto', 10, 30),
  createProduct('leche-005', 'Bebidas - Leche', 'Leche de Soja GUD', '1L', 'Retto', 3, 15, 'especialidad'),

  // BEBIDAS EMBOTELLADAS
  createProduct('embotellado-001', 'Bebidas - Embotelladas', 'San Pellegrino', 'paquete de 24', 'Retto', 1, 5, 'premium'),
  createProduct('embotellado-002', 'Bebidas - Embotelladas', 'San Pellegrino naranja', 'paquete de 6', 'Retto', 2, 10, 'premium'),
  createProduct('embotellado-003', 'Bebidas - Embotelladas', 'San Pellegrino naranja/tuna', 'paquete de 6', 'Retto', 2, 10, 'premium'),
  createProduct('embotellado-004', 'Bebidas - Embotelladas', 'Coco agua', 'paquete de 6', 'Retto', 2, 10, 'premium'),
  createProduct('embotellado-005', 'Bebidas - Embotelladas', 'Coco bebida', 'paquete de 6', 'Retto', 2, 10, 'premium'),

  // POLVOS PARA BEBIDAS
  createProduct('polvo-001', 'Bebidas - Polvos', 'Polvo base neutro, Zaachila', '1.36 kg', 'Discount Coffee', 1, 5),
  createProduct('polvo-002', 'Bebidas - Polvos', 'Polvo Capuchino', '1.36 kg', 'Discount Coffee', 2, 8),
  createProduct('polvo-003', 'Bebidas - Polvos', 'Polvo de chocolate', '1.36 kg', 'Discount Coffee', 2, 8),
  createProduct('polvo-004', 'Bebidas - Polvos', 'Polvo de chocolate mexicano', '1.36 kg', 'Discount Coffee', 1, 5, 'especialidad'),
  createProduct('polvo-005', 'Bebidas - Polvos', 'Polvo de chocolate Oaxaca', '1.36 kg', 'Discount Coffee', 1, 5, 'especialidad'),
  createProduct('polvo-006', 'Bebidas - Polvos', 'Polvo de Crema de Fresa', '1.36 kg', 'Discount Coffee', 1, 5, 'especialidad'),
  createProduct('polvo-007', 'Bebidas - Polvos', 'Polvo Slush Crystal', '1.36 kg', 'Discount Coffee', 1, 5, 'especialidad'),
  createProduct('polvo-008', 'Bebidas - Polvos', 'Polvo Taro', '1.36 kg', 'Discount Coffee', 1, 5, 'especialidad'),

  // PREPARADOS
  createProduct('preparado-001', 'Bebidas - Preparados', 'Preparado de Chai', '1L', 'Grano x Grano Daniel/Javier', 2, 10, 'especialidad'),

  // PULPAS
  createProduct('pulpa-001', 'Bebidas - Pulpas', 'Pulpa de Fresa', '1L', 'Discount Coffee', 2, 10, 'especialidad'),
  createProduct('pulpa-002', 'Bebidas - Pulpas', 'Pulpa de Mango', '1L', 'Discount Coffee', 2, 10, 'especialidad'),
  createProduct('pulpa-003', 'Bebidas - Pulpas', 'Pulpa de Maracuyá', '1L', 'Discount Coffee', 2, 10, 'especialidad'),
  createProduct('pulpa-004', 'Bebidas - Pulpas', 'Pulpa de Piña', '1L', 'Discount Coffee', 2, 10, 'especialidad'),
  createProduct('pulpa-005', 'Bebidas - Pulpas', 'Pulpa de Tamarindo', '1L', 'Discount Coffee', 2, 10, 'especialidad'),

  // TÉ-TISANAS
  createProduct('tisana-001', 'Bebidas - Té/Tisanas', 'Tisana de Mandarina - Chabacano', '450 grs', 'Discount Coffee', 1, 5, 'especialidad'),
  createProduct('tisana-002', 'Bebidas - Té/Tisanas', 'Tisana de Frutos rojos', '450 grs', 'Discount Coffee', 1, 5, 'especialidad'),
  createProduct('tisana-003', 'Bebidas - Té/Tisanas', 'Tisana de Piña colada', '450 grs', 'Discount Coffee', 1, 5, 'especialidad'),
  
  // Soy té products
  createProduct('tisana-004', 'Bebidas - Té/Tisanas', 'Verde Menta', '50 gr', 'Soy té', 2, 10, 'especialidad'),
  createProduct('tisana-005', 'Bebidas - Té/Tisanas', 'Perlas de Jazmín', '50 gr', 'Soy té', 2, 10, 'especialidad'),
  createProduct('tisana-006', 'Bebidas - Té/Tisanas', 'Pirámide Manzanilla Lavanda', '30 pzas', 'Soy té', 2, 10, 'especialidad'),
  createProduct('tisana-007', 'Bebidas - Té/Tisanas', 'Tisana Jocotepec', '250 gr', 'Soy té', 2, 10, 'especialidad'),
  createProduct('tisana-008', 'Bebidas - Té/Tisanas', 'Tisana Azoyú', '250 gr', 'Soy té', 2, 10, 'especialidad'),
  createProduct('tisana-009', 'Bebidas - Té/Tisanas', 'Tisana Frutos Rojos', '250 gr', 'Soy té', 2, 10, 'especialidad'),
  createProduct('tisana-010', 'Bebidas - Té/Tisanas', 'Neblina Púrpura', 'pza', 'Soy té', 2, 10, 'especialidad'),
  createProduct('tisana-011', 'Bebidas - Té/Tisanas', 'Assam', '50 gr', 'Soy té', 2, 10, 'especialidad'),

  // EMPAQUES
  createProduct('empaque-001', 'Empaques', 'Agitadores de madera', 'paquete', 'Ashok y Maryl/Dympco', 5, 20),
  createProduct('empaque-002', 'Empaques', 'Charolas para 4 bebidas', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),
  createProduct('empaque-003', 'Empaques', 'Bolsa de papel craft individual', 'paquete', 'Ashok y Maryl/Dympco', 5, 20),
  createProduct('empaque-004', 'Empaques', 'Bolsa de papel craft grande', 'paquete', 'Ashok y Maryl/Dympco', 5, 20),
  createProduct('empaque-005', 'Empaques', 'Porta-vasos 10 oz', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),
  createProduct('empaque-006', 'Empaques', 'Porta-vasos 16 oz', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),
  createProduct('empaque-007', 'Empaques', 'Papel para etiquetas p/ vasos', 'rollo', 'Ashok y Maryl/Dympco', 2, 10),
  createProduct('empaque-008', 'Empaques', 'Popotes', 'paquete', 'Ashok y Maryl/Dympco', 5, 20),
  createProduct('empaque-009', 'Empaques', 'Tapas 10 oz', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),
  createProduct('empaque-010', 'Empaques', 'Tapas 16 oz', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),
  createProduct('empaque-011', 'Empaques', 'Tapas de pet 16 oz', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),
  createProduct('empaque-012', 'Empaques', 'Vitafilm/clean pack grado alimenticio', 'rollo', 'Ashok y Maryl/Dympco', 2, 10),
  createProduct('empaque-013', 'Empaques', 'Vasos térmicos 10 oz', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),
  createProduct('empaque-014', 'Empaques', 'Vasos térmicos 16 oz', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),
  createProduct('empaque-015', 'Empaques', 'Vasos térmicos 4 oz', 'paquete', 'Ashok y Maryl/Dympco', 5, 20),
  createProduct('empaque-016', 'Empaques', 'Vasos pet 16 oz', 'paquete', 'Ashok y Maryl/Dympco', 10, 50),

  // INSUMOS DE LIMPIEZA BARRA
  createProduct('limpieza-barra-001', 'Limpieza - Barra', 'Bolsa negra mediana', 'caja con 500', 'Bolpack', 1, 5),
  createProduct('limpieza-barra-002', 'Limpieza - Barra', 'Bolsa negra Jumbo', 'caja con 100', 'Bolpack', 1, 5),
  createProduct('limpieza-barra-003', 'Limpieza - Barra', 'Botellas de alcohol de 1L', '1L', 'Ash/Maryl Gastos', 5, 20),
  createProduct('limpieza-barra-004', 'Limpieza - Barra', 'Botellas de cloro de 1L', '1L', 'Ash/Maryl Gastos', 5, 20),
  createProduct('limpieza-barra-005', 'Limpieza - Barra', 'Limpiador Caffeto Espresso', '500 gr', 'Discount Coffee', 2, 10, 'especialidad'),
  createProduct('limpieza-barra-006', 'Limpieza - Barra', 'Limpiador de molinillos Caffeto', '450 gr', 'Discount Coffee', 2, 10, 'especialidad'),
  createProduct('limpieza-barra-007', 'Limpieza - Barra', 'Esponjas lavatrastes', 'paq. 10 pzas', 'Bolpack', 2, 10),
  createProduct('limpieza-barra-008', 'Limpieza - Barra', 'Fabuloso galón', '20 L', 'Bolpack', 1, 5),
  createProduct('limpieza-barra-009', 'Limpieza - Barra', 'Limpiador de cristal', '1L', 'Bolpack', 2, 10),
  createProduct('limpieza-barra-010', 'Limpieza - Barra', 'Limpiatrastes universal', '20 LTS', 'Bolpack', 1, 5),
  createProduct('limpieza-barra-011', 'Limpieza - Barra', 'Limpiador de lancetas Rinza', '1L', 'Discount Coffee', 2, 10, 'especialidad'),
  createProduct('limpieza-barra-012', 'Limpieza - Barra', 'Rollo de Servitoallas', 'rollo', 'Bolpack', 10, 50),
  createProduct('limpieza-barra-013', 'Limpieza - Barra', 'Sanitas dobladas', '100 hojas caja con 20', 'Bolpack', 2, 10),
  createProduct('limpieza-barra-014', 'Limpieza - Barra', 'Toallas de microfibra', 'pza', 'Bolpack', 5, 20),

  // INSUMOS DE LIMPIEZA GENERAL
  createProduct('limpieza-general-001', 'Limpieza - General', 'Aromatizante', '400 ml', 'Bolpack', 2, 10),
  createProduct('limpieza-general-002', 'Limpieza - General', 'Bolsa de basura jumbo', 'caja de 100', 'Bolpack', 1, 5),
  createProduct('limpieza-general-003', 'Limpieza - General', 'Cepillo de mano', 'pza', 'Bolpack', 2, 10),
  createProduct('limpieza-general-004', 'Limpieza - General', 'Escoba de uso rudo', 'pza', 'Bolpack', 2, 10),
  createProduct('limpieza-general-005', 'Limpieza - General', 'Harpic', 'paq 3', 'Bolpack', 2, 10),
  createProduct('limpieza-general-006', 'Limpieza - General', 'Fregona Vileda Easy Wring', 'pza', 'Bolpack', 1, 5),
  createProduct('limpieza-general-007', 'Limpieza - General', 'Repuesto de mopa Vileda', 'pza', 'Bolpack', 2, 10),
  createProduct('limpieza-general-008', 'Limpieza - General', 'Repuesto de trapeador c/ varilla', 'pza', 'Bolpack', 2, 10),
  createProduct('limpieza-general-009', 'Limpieza - General', 'Rollo de papel para baño', 'paq. 12 rollos', 'Bolpack', 5, 20),
  createProduct('limpieza-general-010', 'Limpieza - General', 'Rollo de papel kraft de Sanitas', 'caja de 20', 'Bolpack', 1, 5)
];